export default __webpack_public_path__ + "static/media/PreSeed.6583624a.svg";